
import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DocumentTypeCodeDto, DocumentTypeDto, FiscalFileLocationDto, LandTitleDto, LandTitleRegisterDto, SecurityClassificationDto } from '@cradua/data';
import * as randomize from "randomatic";
import { ConnectionService } from "ng-connection-service";
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { DocumentoperationsComponent } from '../../../../../../../generic-document/src/lib/components/documentoperations/documentoperations.component'

@Component({
  selector: 'cradua-document',
  templateUrl: './document.component.html',
  styleUrls: ['./document.component.scss']
})
export class DocumentComponent implements OnInit {
  @Input() OriginatingModule = "General";
  @Input() OriginatedModuleSpecificId = "Gen";
  @Input() SubmitIsTriggerByparent = false;
  @Input() activitySelectedValue: string;
  @Input() documentTypeCodes: DocumentTypeCodeDto[];
  @Input() documentTypes: DocumentTypeDto[];
  @Input() securityClassifications: SecurityClassificationDto[];
  @Input() fileLocations: FiscalFileLocationDto[];
  @Input() fetchDocuments: LandTitleRegisterDto[];
  @Input() selectedLandTitle: LandTitleDto;
  @Input() isLoadingDocument: boolean;
  @Input() completed: boolean;
  @Input() progress: number;
  @Input() error: string;
  @Input() isInProgress: boolean;
  @Input() isReady: boolean;
  @Input() hasFailed: boolean;
  @Output() emitUpload = new EventEmitter<any>();
  @Output() emitSaveManyDoc = new EventEmitter<any>();
  @Output() emitReset = new EventEmitter<any>();
  @Output() emitCancel = new EventEmitter<any>();
  @ViewChild("file", { static: false }) file;

  public files: Set<File> = new Set();
  documentForm: FormGroup;
  documentArrayForm: FormGroup;
  selectedIndex = null;

  selectedDocument: LandTitleRegisterDto = null;
  showList = true;
  showDoc = false;
  docType = "";
  fileName = "SheetJS.xlsx";
  data: any;
  headData: any; // excel row header
  images = [];
  @ViewChild("fullScreen", { static: true }) divRef: any;
  status = "ONLINE";
  isConnected = true;
  fileExist = true;
  fileExistMsg = "";
  getFileName: string;

  constructor(
    private fb: FormBuilder,
    private connectionService: ConnectionService,
    public dialog: MatDialog,
    ) {
      this.connectionService.monitor().subscribe((isConnected) => {
        this.isConnected = isConnected;
        if (this.isConnected) {
          this.status = "ONLINE";
        } else {
          this.status = "OFFLINE";
        }
      });
    }

  ngOnInit(): void {
    this.createDocumentForm();
  }

  createDocumentForm() {
    this.documentForm = this.fb.group({
      DocumentTitle: ["", Validators.required],
      DocumentTypeCodeId: ["", Validators.required],
      DocumentTypeId: ["", Validators.required],
      SecurityId: null,
      FileLocationId: null,
      Remarks: null,
      Url: null,
      FileName: ["", Validators.required],
      FilePath: [""],
      FileType: [""],
      ApprovalStatus: ['NOT APPROVED'],
      LandTitleCode: this.selectedLandTitle.id,
      id: null
    });


  }

  onReset() {
    this.documentForm.reset();
  }

  onEdit(value) {

    this.documentForm.patchValue(value);
  }


  // onUpdate(doc: LandTitleRegisterDto) {
  //   doc.DocRefNo = `${this.getDocumentTypeCodeName(doc.DocumentTypeCodeId)}_${randomize("0", 6)}`;
  //   doc.SecurityClassificationName = this.getSecurityClassificationName(doc.SecurityId);
  //   if(this.selectedIndex != null) {
  //     this.storageLocationFormArray['controls'][this.selectedIndex].patchValue({
  //       DocumentTitle:  doc.DocumentTitle,
  //       DocumentTypeCodeId:  doc.DocumentTypeCodeId,
  //       DocumentTypeId:  doc.DocumentTypeId,
  //       SecurityId:  doc.SecurityId,
  //       FileLocationId: doc.FileLocationId,
  //       Remarks: doc.Remarks,
  //       Url: doc.Url,
  //       FileName: doc.FileName,
  //       DocRefNo: doc.DocRefNo,
  //       FilePath: doc.FilePath,
  //       FileType: doc.FileType,
  //         id: doc.id
  //     })
  //   }
  //   this.selectedIndex = null;
  //   this.documentForm.reset();
  // }

  onSelectDoc(doc: LandTitleRegisterDto) {
    this.selectedDocument = doc;
    // this.documentForm.patchValue(doc);
    if(doc.FilePath === null) {
      return;
    }
    const dialogConfig = new MatDialogConfig();

    // dialogConfig.disableClose = false;
    dialogConfig.id = "modal-component";
    dialogConfig.height = "100%";
    dialogConfig.width = "100%";
    // dialogConfig.minHeight = '100vh';
    // dialogConfig.minWidth = '100%'
    // dialogConfig.panelClass = "custom-dialog-container";
    // dialogConfig.backdropClass = "backdropBackground";
    dialogConfig.data = {
      doc
    };

    const dialogRef = this.dialog.open(
      DocumentoperationsComponent,
      dialogConfig,
    );
  }


  onFilesAdded(event) {
    const [file] = event.target.files;
    this.getFileName = file?.name;
    this.documentForm.patchValue({
      FileName:file.name,
      FileType:file.type,
      FilePath:file,
      });
  }

  addFiles() {
    this.file.nativeElement.click();
  }

  protected filterById = <T>(id: string, lookupId: string) =>
  (fieldName: T) => fieldName[lookupId] === id;


  getDocumentTypeName(id: string) {
    const found = this.documentTypes.find(
      this.filterById<DocumentTypeDto>(id, "id"),
    );
    return found ? found.DocumentTypeName : null;
    }

    getDocumentTypeCodeName(id: string) {
      const found = this.documentTypeCodes.find(
        this.filterById<DocumentTypeCodeDto>(id, "id"),
      );
      return found ? found.DocumentTypeCodeName : null;
      }

      getSecurityClassificationName(id: string) {
        const found = this.securityClassifications.find(
          this.filterById<SecurityClassificationDto>(id, "id"),
        );
        return found ? found.SecurityClassificationName : null;
        }


  onSubmit(value: LandTitleRegisterDto) {
    value.DocRefNo = `${this.getDocumentTypeCodeName(value.DocumentTypeCodeId)}_${randomize("0", 6)}`;
    value.SecurityClassificationName = this.getSecurityClassificationName(value.SecurityId);
    if(value.id === null) {
      value['id'] = undefined;
       }
    this.emitUpload.emit(value);
    this.createDocumentForm();
  }

  onUploadDoc(value) {
    value.forEach(doc => {
      doc.DocRefNo = `${this.getDocumentTypeCodeName(doc.DocumentTypeCodeId)}_${randomize("0", 6)}`;
      doc.SecurityClassificationName = this.getSecurityClassificationName(doc.SecurityId);
      this.emitUpload.emit(doc);
    })
    // console.log('docc ', value);
  }

  onSaveManyDoc(value: LandTitleRegisterDto[]) {
    this.emitSaveManyDoc.emit(value);
  }

  onResetUpload() {
    this.emitReset.emit("");
  }

  onCancelUpload() {
    this.emitCancel.emit("");
  }

  doesFileExist(urlToFile) {
    const xhr = new XMLHttpRequest();
    xhr.open("HEAD", urlToFile, false);
    xhr.send();
    if (xhr.status === 404) {
      return false;
    } else {
      return true;
    }
  }

  doesFileExistwithURL() {
    const urlMain = this.documentForm.value.Url;
    if (urlMain === null) {
      return;
    }
    const result = this.doesFileExist(urlMain);

    if (result === true) {
      this.fileExist = true;
    } else {
      // console.log("InValid path");
      this.fileExist = false;
      this.fileExistMsg =
        "The Url supplied couldn't resolve to a file as a result of no internet connectivity or the url does not exist, please cross check or ignore to continue";
    }
  }


}
